import React from 'react';
import classNames from 'classnames';

import Avatar from 'components/Avatar';

import './styles.css';

export const BookingTenantsInfo = ({tenants}) => (
  <div className="BookingTenantsInfo">
    <div className="BookingTenantsInfo__Avatars">
      {tenants.map(tenant => (
        <Avatar
          url={tenant.internalAvatarCropped || tenant.avatarCropped}
          initials={tenant.initials}
          key={tenant.email}
          width={64}
        />
      ))}
    </div>
    <div className="BookingTenantsInfo__names">
      {tenants.map(tenant => (
        <div className="colab-bold" key={tenant.email}>
          {tenant.fullName}
        </div>
      ))}
    </div>
  </div>
);

export const DetailTenantInfo = ({tenant}) => {
  const {
    avatarCropped,
    internalAvatarCropped,
    fullName,
    initials,
    email
  } = tenant;
  return (
    <div className="TenantInfo colab-centered-v">
      <Avatar
        url={internalAvatarCropped || avatarCropped}
        initials={initials}
      />
      <div className="info">
        <p className="name colab-bold">{fullName}</p>
        <p className="email">{email} </p>
      </div>
    </div>
  );
};

export const DetailTeamInfo = ({team}) => {
  const {membersCount, avatarUrl, name} = team;

  return (
    <div className="DetailTeamInfo colab-centered-v">
      <Avatar url={avatarUrl} initials="" />
      <div className="info">
        <p className="name, colab-bold">{name}</p>
        <p className="membersCount">{membersCount} members</p>
      </div>
    </div>
  );
};

export const PartialTenantInfo = ({tenant, white}: any) => {
  const {avatarCropped, internalAvatarCropped, fullName, initials} = tenant;

  return (
    <div className="PartialTenantInfo">
      <Avatar
        url={internalAvatarCropped || avatarCropped}
        initials={initials}
        white={white}
        key={internalAvatarCropped || avatarCropped}
      />
      <div className="info">
        <p className={classNames('name colab-bold', {white})}>{fullName}</p>
      </div>
    </div>
  );
};

export const TenantInfoOption = option => {
  const {
    avatarCropped,
    internalAvatarCropped,
    fullName,
    initials,
    email
  } = option.object;
  return (
    <div className="TenantInfoOption">
      <Avatar
        url={internalAvatarCropped || avatarCropped}
        initials={initials}
      />
      <div className="info">
        <p className="email">{email} </p>
        <p className="name">{fullName}</p>
      </div>
    </div>
  );
};
